import { PaginateData, PaginateOptions } from './../utils/paginate.utils';
import { Injectable } from "@angular/core";
import { GlobalCacheService } from './global-cache.service';
import { ApiService } from './api.service';
import { TituloInterface } from "../models/titulo.model";
import { Observable, shareReplay } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TituloService extends ApiService<TituloInterface> {
  url = "titulos";
  maxEntries = 50;

  asignarTitulosAPersona(data: { dni: number, titulos: number[] }) {
    return this.http.post(`${this.getApiUrl()}/asignar`, data);
  }

  constructor(
    private globalCache: GlobalCacheService
  ) {
    super();
  }

  getCompetenciasByTitulo = (id: number) => {
    const data = this.http.get(`${this.getApiUrl()}/competencias/${id}`);
    return data;
  }

  getByDni = (paginateOptions: PaginateOptions, dni: number, ignoreCache = false): Observable<PaginateData<TituloInterface>> => {
    const params = {};
    const cacheKey = `${JSON.stringify(paginateOptions)}-dni-${dni}-${JSON.stringify(params)}`;
    if (ignoreCache) {
      // Siempre borra el observable anterior si ignoreCache es true
      this._getContent.delete(cacheKey);
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(this.getApiUrl() + '/por-dni/' + dni, {
          params: {
             ...paginateOptions
          }        }).pipe(shareReplay({ bufferSize: 1, refCount: true }))
      );
    }
    return this._getContent.get(cacheKey)!;
  }
}
